import React, { useContext, useMemo } from "react";

import "./EUMRVVoyages.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	EUMRV_VOYAGES_HEADERS,
	EUVoyagesDerogationCCSandCCUColumns,
} from "../../../../../../constants/CustomTableHeaders";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { FeatureType } from "../../../../../../constants/FeatureToggles";

const EuVoyagesDerogationCCSandCCU = ({ data }) => {
	const mrvAccessorKeys = [
		"co2EqMrv"];
	//feature toggle for blend fuel registry
	const { claims, userHasFeature } = useContext(ClaimsContext) || {};
	const dynamicColumns = useMemo(() => {
			return EUVoyagesDerogationCCSandCCUColumns?.filter(
				col => ((col.header && (col.header.includes("Port of Departure") || col.header.includes("Port of Arrival"))) || !mrvAccessorKeys.includes(col.accessorKey))
			);
		
	}, [EUVoyagesDerogationCCSandCCUColumns]);

	return (
		<div className="EUMRV-custom-table-container mt-3 eu_mrv_voyage">
			<CustomTable
				columnsData={dynamicColumns}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_VOYAGES_HEADERS.CCS_CCU,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default EuVoyagesDerogationCCSandCCU;
